import { createSlice } from '@reduxjs/toolkit';

import { loadServiceProvider, loadServiceProviderLogo } from './service-provider.middleware';
import { logout } from '../auth/auth-middleware';
import { ServiceProvider } from 'api';

type ServiceProviderState = {
    entity: ServiceProvider | null;
    logo_url: string;
};

const initialState: ServiceProviderState = {
    entity: null,
    logo_url: '',
};

export const serviceProviderSlice = createSlice({
    name: 'app/visa-process/service-provider',
    initialState,
    reducers: {
        reset: (state) => {
            state.entity = null;
            state.logo_url = '';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadServiceProvider.fulfilled, (state, action) => {
                state.entity = action.payload.data;
            })
            .addCase(loadServiceProviderLogo.fulfilled, (state, action) => {
                const path = action.payload.data.url ? action.payload.data.url : '';
                state.logo_url = path;
            })
            .addCase(logout.fulfilled, (state) => {
                state.entity = null;
                state.logo_url = '';
            });
    },
});

export default serviceProviderSlice.reducer;
